import "./index.scss";

const VerticalGap = () => {
  return <div className="vertical-gap"></div>;
};
export default VerticalGap;
